import { NgModule } from '@angular/core';

import { DistributionApiToWireConverter } from './converters/distribution-api-to-wire.converter';
import { DistributionBlockApiModelToWireBlockApiModelConverter } from './converters/distribution-block-api-to-wire-block-api.converter';

import { AmplifyContentService } from './services/amplify-content.service';


@NgModule({
    imports: [
    ],
    providers: [
        AmplifyContentService,
        DistributionApiToWireConverter,
        DistributionBlockApiModelToWireBlockApiModelConverter
    ],
    exports: [
    ]
})
export class AmplifySharedModule { }
